import connectToStores from 'alt-utils/lib/connectToStores'
import { PlusActions, SEOSettingsActions } from 'actions'
import { CheckStore, PlusStore, SEOSettingsStore } from 'stores'
import { ManagePlus } from 'components'

@connectToStores
export default class ManagePlusContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [
      PlusStore,
      CheckStore,
      SEOSettingsStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState(),
      ...CheckStore.getState(),
      ...PlusStore.getState()
    }
  }

  componentWillMount() {
    PlusActions.fetch()

    if (!this.props.settings) {
      SEOSettingsActions.fetch()
    }

    const queryString = require("query-string")
    const { autoInstall } = queryString.parse(this.props.location.search)

    // clear the autoInstall from browser history to prevent rerunning when
    // navigating back here
    if (autoInstall) {
      const url = window.location.href.replace(/\?.*$/, "")
      window.history.replaceState({}, document.title, url)
    }

    this.setState({ autoInstall: !!autoInstall })
  }

  render() {
    return (
      <ManagePlus
        checks       = {this.props.checks}
        settings     = {this.props.settings}
        isInstalling = {this.props.isInstalling}
        installed    = {this.props.installed}
        isUpgrade    = {this.props.isUpgrade}
        status       = {this.props.status}
        failed       = {this.props.failed}
        installNow   = {this.state.autoInstall}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/ManagePlusContainer.js